/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GenderDto } from '../models/PagedResultDto_GenderDto';
import type { Wealthlane_CustomerService_Dtos_Gender_CreateUpdateGenderDto } from '../models/Wealthlane_CustomerService_Dtos_Gender_CreateUpdateGenderDto';
import type { Wealthlane_CustomerService_Dtos_Gender_GenderDto } from '../models/Wealthlane_CustomerService_Dtos_Gender_GenderDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GenderService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Gender_GenderDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppGenderGenderList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Gender_GenderDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/gender/gender-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Gender_GenderDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppGender(
requestBody?: Wealthlane_CustomerService_Dtos_Gender_CreateUpdateGenderDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Gender_GenderDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/gender',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_GenderDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppGender(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_GenderDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/gender',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Gender_GenderDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppGender(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_Gender_CreateUpdateGenderDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Gender_GenderDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/gender/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppGender(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/gender/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Gender_GenderDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppGender1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Gender_GenderDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/gender/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
